<template>
    <div class="main-content">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h5>Статистика заявок</h5>
                    </div>
                    <div class="card-body">

                        <div class="range_picker">
                            <date-range-picker
                                    ref="picker"
                                    :startDate="startDate"
                                    opens="right"
                                    :ranges="ranges"
                                    :locale-data="date_locale"
                                    v-model="dateRange"
                            >
                            </date-range-picker>
                            <vue-ladda @click="showStatistics" button-class="btn btn-info"
                                       data-style="zoom-in"
                                       :loading="loading">Показать статистику
                            </vue-ladda>
                        </div>

                        <div class="row">
                            <div class="col-md-12 m-t-20" v-if="dataUploaded">
                                <table class="table table-hover table-bordered">
                                    <thead>
                                    <tr>
                                        <th>

                                        </th>
                                        <th colspan="2" v-for="(column, index) in table_columns" :key="index">
                                            {{column.name}}
                                        </th>
                                        <th colspan="2">Итого</th>
                                    </tr>
                                    </thead>
                                    <tbody v-for="(date, index2) in dates" :key="index2">
                                    <template v-if="main_total[date]">
                                        <tr>
                                            <td class="text-center date_row" colspan="20">{{date}}</td>
                                        </tr>
                                        <tr v-for="(row, index3) in table_rows" :key="index3"
                                            :class="checkTotalLine(row.city)">
                                            <td>{{row.name}}</td>
                                            <template v-for="(col, index4) in table_columns">
                                                <td :key="index4">{{printData(main_total, date, row, index4, 'qnty')}}
                                                </td>
                                                <td>{{printData(main_total, date, row, index4, 'cost')}}
                                                </td>
                                            </template>
                                            <td class="light_gray">
                                                {{total_line_figures[date][row.source][row.city].qnty}}
                                            </td>
                                            <td class="light_gray">
                                                {{total_line_figures[date][row.source][row.city].cost}}
                                            </td>
                                        </tr>
                                        <tr class="total_line">
                                            <td>Итого общее</td>
                                            <template v-for="(site, index6) in table_columns">
                                                <td>
                                                    <v-popover
                                                            placement="left"
                                                            trigger="hover"
                                                    >
                                                        <div>{{printTotal(date, index6, 'qnty')}}</div>

                                                        <template slot="popover">
                                                            <div v-html="`${printTooltip(date, 'qnty', index6)}`"></div>
                                                        </template>
                                                    </v-popover>
                                                </td>
                                                <td>
                                                    <v-popover
                                                            placement="left"
                                                            trigger="hover"
                                                    >
                                                        <div>{{printTotal(date, index6, 'cost')}}</div>

                                                        <template slot="popover">
                                                            <div v-html="`${printTooltip(date, 'cost', index6)}`"></div>
                                                        </template>
                                                    </v-popover>
                                                </td>
                                            </template>
                                            <td>
                                                <v-popover
                                                        placement="left"
                                                        trigger="hover"
                                                >
                                                    <div>{{printGrandTotal(date, 'qnty')}}</div>

                                                    <template slot="popover">
                                                        <div v-html="`${printTooltip(date, 'qnty', 'total')}`"></div>
                                                    </template>
                                                </v-popover>
                                            </td>
                                            <td>
                                                <v-popover
                                                        placement="left"
                                                        trigger="hover"
                                                >
                                                    <div>{{printGrandTotal(date, 'cost')}}</div>

                                                    <template slot="popover">
                                                        <div v-html="`${printTooltip(date, 'cost', 'total')}`"></div>
                                                    </template>
                                                </v-popover>

                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import api from '@/api'
    import moment from 'moment'
    import DateRangePicker from 'vue2-daterange-picker'
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
    import VueLadda from 'vue-ladda/src/vue-ladda.vue'
    import VTooltip from 'v-tooltip'

    export default {
        components: {
            DateRangePicker,
            VueLadda,
            moment,
            VTooltip
        },
        data() {
            return {
                msg: 'dsadsa',
                loading: false,
                dateRange: {
                    startDate: moment(),
                    endDate: moment(),
                },
                startDate: '2019-10-17',
                date_locale: {
                    firstDay: 1,
                    format: 'DD-MM-YYYY',
                    applyLabel: 'Выбрать',
                    cancelLabel: 'Отмена',
                },
                ranges: { //default value for ranges object (if you set this to false ranges will no be rendered)
                    'Сегодня': [moment(), moment()],
                    'Вчера': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                    'Текущая неделя': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
                    'Прошлая неделя': [moment().subtract(1, 'isoWeek').startOf('isoWeek'), moment().subtract(1, 'isoWeek').endOf('isoWeek')]
                },
                dataUploaded: false,
                dates: {},
                table_columns: {},
                table_rows: {},
                main_total: {},
                total_figures: {},
                total_line_figures: {},
                total_row_figures: {},
                grant_total: {},
                cities: {}
            }
        },
        methods: {
            printTooltip(date, field, index) {
                var html = '';
                Object.keys(this.grant_total[date][index]).map((objectKey, index2) => {
                    try {
                        html += '<p>' + this.cities[objectKey] + ' - ' + this.grant_total[date][index][objectKey][field] + '</p>';
                    } catch (e) {
                    }
                });
                return html;
            },
            checkTotalLine(name) {
                return name == 'total' ? 'light_gray' : ''
            },
            printGrandTotal(date, field) {
                var sum = 0
                Object.keys(this.main_total[date].manual.total).map((objectKey, index) => {
                    sum += this.main_total[date].manual.total[objectKey][field]
                });
                Object.keys(this.main_total[date].site.total).map((objectKey, index) => {
                    sum += this.main_total[date].site.total[objectKey][field]
                });
                return sum
            },
            printTotal(date, index, field) {

                let manual = 0;
                try {
                    manual = this.main_total[date].manual.total[index][field];
                } catch (e) {
                }
                let site = 0;
                try {
                    site = this.main_total[date].site.total[index][field];
                } catch (e) {
                }
                return manual + site;
            },
            printData(main_total, date, row, index, field) {
                if (typeof main_total[date][row.source][row.city][index] !== 'undefined') {
                    return main_total[date][row.source][row.city][index][field]
                }
                return 0
            },
            async showStatistics() {
                this.loading = true
                const {data} = await api.store('/analytics/getOrderStatistic', {
                    data: {
                        startDate: this.dateRange.startDate.toLocaleString(),
                        endDate: this.dateRange.endDate.toLocaleString()
                    }
                })
                this.dates = data.dates;
                this.table_columns = data.table_columns;
                this.table_rows = data.table_rows
                this.main_total = data.main_total
                this.total_line_figures = data.total_line_figures
                this.grant_total = data.grant_total
                this.cities = data.cities

                this.dataUploaded = true;
                this.loading = false
            }
        }
    }
</script>

<style>
    .daterangepicker td.active,
    .daterangepicker td.active:hover,
    .daterangepicker .ranges li.active {
        background-color: #5BBFDE !important;
    }

    .wrapper .tooltip-inner.popover-inner {
        background-color: white;
        color: black;
        padding: 10px;
    }

    .wrapper .tooltip-inner.popover-inner p {
        margin-bottom: 5px;
    }

</style>

<style scoped>
    .range_picker .btn.ladda-button {
        padding: 4px 17px;
    }

    table.table td {
        padding: 3px;
    }

    table.table th {
        text-align: center;
    }

    .total_line td {
        background-color: #b5eaff;
    }

    .date_row {
        background-color: #f1fbff;
    }

    .light_gray {
        background-color: #f3f3f3;
    }
    td div.v-popover{
        cursor: pointer;
    }

</style>
